var _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFjLogoCompanyName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 11,
    viewBox: "0 0 114 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6325 0.177734V10.7951H24.2946V7.07484H27.6731V4.77113H24.2946V2.51884H28.0824V0.177734H21.6325Z",
    fill: "#30538F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1959 0.177734V10.7951H38.9049V8.45395H34.8575V0.177734H32.1959Z",
    fill: "#30538F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1062:2123",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 0,
    width: 12,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0616 0H53.1251V10.9713H42.0616V0Z",
    fill: "#30538F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1062:2123)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5831 2.38912C45.976 2.38912 44.7948 3.62434 44.7948 5.48133C44.7948 7.33729 45.976 8.58342 47.5831 8.58342C49.1908 8.58342 50.3715 7.35131 50.3715 5.4912C50.3715 3.63161 49.2111 2.39275 47.5831 2.39275V2.38912ZM47.5832 0C50.6547 0 53.1251 2.24917 53.1251 5.48423C53.1251 8.71982 50.6578 10.9716 47.5832 10.9716C44.5087 10.9716 42.0616 8.71982 42.0616 5.48423C42.0616 2.24917 44.5087 0 47.5832 0Z",
    fill: "#30538F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1062:2123",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 0,
    width: 10,
    height: 11
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8691 0.00976562H65.4383V10.9903H56.8691V0.00976562Z",
    fill: "#30538F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1062:2123)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2233 3.51888C64.454 2.77297 63.4177 2.36729 62.3461 2.39274C60.5956 2.39274 59.5962 3.67939 59.5962 5.48444C59.5962 7.36169 60.739 8.57666 62.4526 8.57666C63.5512 8.59795 64.6181 8.20266 65.4383 7.47077V10.2009C64.4992 10.7567 63.4198 11.0294 62.3295 10.9858C58.9848 10.9858 56.8691 8.71639 56.8691 5.49846C56.8691 2.28002 59.0497 0.0142308 62.3295 0.0142308C63.3382 -0.0262855 64.3387 0.20954 65.2233 0.696773V3.51888Z",
    fill: "#30538F"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6798 0.177748H78.7512L75.3385 5.32435L78.9834 10.7842H75.8538L72.4411 5.52901L75.6798 0.177748ZM69.7278 10.7945H72.3899V0.177734H69.7278V10.7945Z",
    fill: "#30538F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0061 7.79167C82.5494 8.255 83.2372 8.5142 83.9514 8.52563C84.5758 8.52563 85.1118 8.38227 85.1118 7.52208V0.177734H87.7734V7.82543C87.7734 9.91773 86.4083 10.9722 84.3264 10.9722C83.5161 11.0101 82.7125 10.8044 82.0196 10.3816L82.0061 7.79167Z",
    fill: "#30538F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.643 2.83984L95.2779 6.59383H98.0081L96.643 2.83984ZM94.4627 8.77444L93.7324 10.7951H90.9274L95.0528 0.177734H98.2541L102.38 10.7951H99.4691L98.7528 8.77444H94.4627Z",
    fill: "#30538F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.052 0.177734H114L110.175 6.93511V10.7945H107.53V6.93511L103.722 0.177734H106.653L108.906 4.3961L111.052 0.177734Z",
    fill: "#30538F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06392 2.91839C9.69495 2.91839 10.4528 2.35844 10.6299 1.13672C9.9474 1.62499 9.09137 1.75121 8.01976 1.75121C4.83924 1.75121 4.99248 3.1163 3.72972 4.33802C3.16665 4.88395 2.06804 4.95927 1.78442 4.67929C1.78442 5.44027 2.71266 5.76128 3.3204 5.76128C3.89438 5.77063 4.45018 5.5587 4.87301 5.17068C6.08797 3.98324 5.73631 2.91839 8.06392 2.91839Z",
    fill: "#30538F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1062:2123",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 12,
    height: 6
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.18359H11.6814V10.1598H0V5.18359Z",
    fill: "#30538F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1062:2123)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07417 5.85263C8.10489 5.85263 7.16315 5.85263 6.344 6.66503C5.63392 7.37147 4.70569 8.57605 3.9551 8.57605C2.41236 8.57605 2.12252 7.85247 1.25558 7.85247C0.596927 7.84572 -0.000427246 8.25867 -0.000427246 8.92407C0.842622 8.08154 2.13291 10.1598 4.11872 10.1598C5.32694 10.1598 5.96169 9.21444 6.50762 8.65812C6.63073 8.53501 7.48053 7.14967 9.07417 7.14967C10.4392 7.14967 11.5109 6.53881 11.6812 5.18359C10.9987 5.90042 10.1489 5.85263 9.07417 5.85263Z",
    fill: "#30538F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFjLogoCompanyName);
export default __webpack_public_path__ + "static/media/FJLogo-CompanyName.108659b78a8926d2316bc4b35d40c995.svg";
export { ForwardRef as ReactComponent };